import React from "react";
import { PantsIcon } from "../../icons/PantsIcon";
import "./lazer-open-modal-button.scss";
import { EditBrushIcon } from "../../icons/EditBrushIcon";
import { LazerIcon } from "../../icons/LazerIcon";
import { DamageIcon } from "../../icons/DamageIcon";
import { CustomDesignIcon } from "../../icons/CustomDesignIcon";
export type ILazerOpenModalButtonProps = {
  onClick: () => void;
  title: any;
  type: any;
};

const LazerOpenModalButton: React.FC<ILazerOpenModalButtonProps> = ({
  onClick,
  title,
  type,
}) => {
  return (
    <button type="button" className="lazer-open-modal-button" onClick={onClick}>
      <div className="lazer-btn-left-col">
        <PantsIcon />
        <div className="lazer-txt">
          <div className="lazer-txt-black">{title}</div>
          <div className="lazer-txt-silver">Front / Back</div>
        </div>
      </div>
      <div className="icon-brush-container">
        {/* <EditBrushIcon /> */}
        {type == "lazer" ? (
          <>
            <LazerIcon />
          </>
        ) : type == "dammages" ? (
          <>
            <DamageIcon />
          </>
        ) : (
          <CustomDesignIcon />
        )}
      </div>
    </button>
  );
};

export { LazerOpenModalButton };
